import React, { Component } from 'react';
import PropTypes from 'prop-types';
import deepEqual from 'deep-equal';
import _ from 'underscore';
import { unescapeHTML } from 'underscore.string';
import { Col, Row, FormControl, ControlLabel } from 'react-bootstrap';
import LocationAutosuggest from 'components/site/location-autosuggest';
import SearchBox from 'components/site/SearchBox';
import { withTranslation, Trans } from 'react-i18next';
import CargomaticInput from 'components/v2/input';
function getLocation(item) {
    if (item && item.name) {
        return item.name;
    }
    return 'Unknown Location Name';
}
const createOnRemove = (item, onClick) => (e) => {
    e.stopPropagation();
    onClick(item);
};
const createRenderItem = (onClick) => (item) => (React.createElement("a", { key: item._id, className: "list-group-item", style: { cursor: 'pointer' } },
    React.createElement("div", { className: "flex justify-between" },
        React.createElement("p", { style: { cursor: 'pointer' }, className: "list-group-item-heading" },
            React.createElement("span", { className: "searchName" }, getLocation(item))),
        React.createElement("button", { className: "button px-4 text-xl", onClick: createOnRemove(item, onClick) },
            React.createElement("i", { className: "fa fa-close text-xl text-grey hover:text-grey-darker" })))));
class Location extends Component {
    constructor(props) {
        super(props);
        this.search = (nGram) => {
            const searchTerm = (nGram || '').toLowerCase();
            const filteredItems = (this.props.locations || []).filter((c) => (c.name || '').toLowerCase().includes(searchTerm));
            const items = _.sortBy(filteredItems, (l) => (l.name || '').toLowerCase());
            this.setState({ items });
        };
        this.handleRemoveLocation = (locationId) => {
            this.props.onRemoveLocation(locationId);
        };
        this.handleAutocompleteNameChange = (item) => this.props.onChange('name', item);
        this.handleNameChange = (value) => this.props.onChange('name', value);
        this.handleNameSelect = (value, item) => this.props.onNameSelect(item);
        this.handleAddressSelect = (item) => {
            this.setState({
                suggestions: [{ item }],
            }, () => {
                this.props.onAddressSelect({ location: item, label: item.address });
            });
        };
        this.handleSuiteOrAptChange = (e) => this.props.onChange('suite_or_apt', e.target.value);
        this.state = { items: props.locations };
        const location = props.location || {};
        const name = location.name || '';
        if (name) {
            this.search(name);
        }
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!deepEqual(this.props.locations, nextProps.locations)) {
            const items = nextProps.locations;
            this.setState({ items });
        }
        if (!deepEqual(this.props.location.name, nextProps.location.name)) {
            this.search(nextProps.location.name);
        }
    }
    clear() {
        this.setState({ items: [] });
    }
    render() {
        const { location, locations, label, t } = this.props;
        const hasLocations = locations && locations.length > 0;
        return (React.createElement("div", { className: "grid grid-cols-6 gap-4" },
            React.createElement("div", { id: `${label ? label + '-' : ''}location-details`, className: "col-span-full" },
                React.createElement("div", { className: "flex items-center space-x-1" },
                    React.createElement(Trans, { i18nKey: "NAME_REQUIRED", components: [
                            React.createElement("label", { className: "mb-1 form-label" }),
                            React.createElement("small", { className: "text-muted" }),
                        ] })),
                hasLocations && (React.createElement("div", { className: "mb-4" },
                    React.createElement(SearchBox, { id: `${label ? label + '-' : ''}name`, appendItems: true, items: this.state.items, clear: () => this.clear(), search: (nGram) => this.search(nGram), placeholder: t('NAME', { count: 1 }), onChange: this.handleAutocompleteNameChange, onSelect: this.handleNameSelect, value: unescapeHTML(location.name), getItemValue: getLocation, renderItem: createRenderItem(this.handleRemoveLocation) }))),
                !hasLocations && (React.createElement("div", { className: "mb-4" },
                    React.createElement(CargomaticInput, { id: `${label ? label + '-' : ''}name`, placeholder: t('NAME', { count: 1 }), value: unescapeHTML(location.name), type: "text", onChange: this.handleNameChange, hideLabel: true })))),
            React.createElement("div", { className: "col-span-4", id: `${label ? label + '-' : ''}address` },
                React.createElement(Trans, { i18nKey: "ADDRESS_REQUIRED", components: [
                        React.createElement(ControlLabel, { className: "mb-2" }),
                        React.createElement("small", { className: "text-muted" }),
                    ] }),
                React.createElement("div", { className: "mb-4" },
                    React.createElement(LocationAutosuggest, { className: "mb-4", key: location.address.label, id: `${label ? label + '-' : ''}autosuggest-address`, name: unescapeHTML(location.name), address: location.address.label, value: location.address.label, suggestions: [
                            {
                                name: unescapeHTML(location.name),
                                address: location.address.label,
                            },
                        ], callbackSelectedItem: this.handleAddressSelect }))),
            React.createElement("div", { className: "col-span-2" },
                React.createElement("label", { className: "mb-1 form-label" }, t('SUITE_APT')),
                React.createElement("div", { className: "mb-4" },
                    React.createElement("input", { type: "text", className: "form-field", placeholder: "1A", onChange: this.handleSuiteOrAptChange, value: location.suite_or_apt })))));
    }
}
Location.propTypes = {
    location: PropTypes.object.isRequired,
    locations: PropTypes.array,
    onAddressSelect: PropTypes.func.isRequired,
    onNameSelect: PropTypes.func,
    onChange: PropTypes.func.isRequired,
    onRemoveLocation: PropTypes.func.isRequired,
};
Location.defaultProps = {
    locations: [],
    onNameSelect: () => { },
};
export default withTranslation()(Location);
